// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"9b2d27b5","101":"5cc68c92","121":"29661a1b","384":"559cd396","402":"e8a69997","430":"fe77b4b3","460":"7859a2c4","471":"4b9d9f6d","497":"1c0b94a6","537":"2150e11e","700":"9793de15","774":"1132c9f1"}[chunkId] + ".chunk.js";
};